import type { TransferBatch } from '../types/uploader';

export const getProgressType = (job: TransferBatch) =>
  job?.progress?.progressType || job?.batchType;
